export const SupportedTypes = [
    { label: "File", dataType: "file", value: "File" },
    {
        label: "Content",
        dataType: "model",
        value: "CMSContent",
        isCMSModel: true, // Has nested content.* structure
        searchFields: "content.name content.title content.type content.id"
    },
    {
        label: "Content Type",
        dataType: "model",
        value: "CMSType",
        isCMSModel: true, // Has nested content.* structure
        searchFields: "content.type content.label"
    },
    {
        label: "Store Price",
        dataType: "model",
        value: "StorePrice",
        isCMSModel: false, // Direct database model
        searchFields: "price_id name"
    },
    {
        label: "Store Product",
        dataType: "model",
        value: "StoreProduct",
        isCMSModel: false, // Direct database model
        searchFields: "name pid type description"
    },
    {
        label: "Users",
        dataType: "model",
        value: "User",
        isCMSModel: false, // Direct database model
        searchFields: "email name username"
    },
    {
        label: "Devices",
        dataType: "model",
        value: "UserDevice",
        isCMSModel: false, // Direct database model
        searchFields: "device_id platform"
    },
    {
        label: "Localization",
        dataType: "model",
        value: "Localization",
        isCMSModel: false, // Direct database model
        searchFields: "key value language"
    }
]
